import { useTranslation } from "react-i18next";

import ph1 from '../../img/About/ph_d.png'
import ph2 from '../../img/About/ph_m.png'

import gr from '../../img/About/gr.png'

import Fade from 'react-reveal/Fade';

import Button from '../Button'

function JoinOver () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] relative mx-[20px] flex flex-col xl:flex-row xl:mx-auto bg-[#A3E9E6] rounded-[20px]">
               <div className="px-[20px] xl:px-[70px] pt-[60px]">
                    <p className="manrope text-[24px] xl:text-[48px] font-[500] leading-[1.2]">{t('about.33')}</p>
                    <p className="manrope text-[20px] xl:text-[32px] font-[500] leading-[1.2] mt-[6px] xl:mt-[8px]">{t('about.34')}</p>
                    <div className="mt-[25px] xl:mt-[35px] flex flex-col xl:flex-row items-start xl:items-center gap-[25px] xl:gap-[60px]">
                        <img src={gr} alt="" />
                        <Button/>
                    </div>
               </div>
               <Fade right><img src={ph1} className="hidden xl:block" alt="" /></Fade>
               <Fade><img src={ph2} className="xl:hidden mt-[45px]" alt="" /></Fade>
            </div>
        </div>
    );
}

export default JoinOver;  